/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Learnmoreteam2Inputs */

const zh_share_learnmoreteam2 = /** @type {(inputs: Share_Learnmoreteam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队：仅限团队成员访问。`)
};

const en_share_learnmoreteam2 = /** @type {(inputs: Share_Learnmoreteam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team: Only team members can access.`)
};

const es_share_learnmoreteam2 = /** @type {(inputs: Share_Learnmoreteam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo: Solo los miembros del equipo pueden acceder.`)
};

/**
* | output |
* | --- |
* | "Team: Only team members can access." |
*
* @param {Share_Learnmoreteam2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_learnmoreteam2 = /** @type {((inputs?: Share_Learnmoreteam2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Learnmoreteam2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_learnmoreteam2(inputs)
	if (locale === "en") return en_share_learnmoreteam2(inputs)
	return es_share_learnmoreteam2(inputs)
});
export { share_learnmoreteam2 as "share_learnMoreTeam" }